export const FETCH_FAQS = 'faqs/FETCH_FAQS';
export const FETCH_FAQS_SUCCESS = 'faqs/FETCH_FAQS_SUCCESS';
export const FETCH_FAQS_FAILED = 'faqs/FETCH_FAQS_FAILED';
